// extracted by mini-css-extract-plugin
export default {"logo_wrapper":"CarBrend_logo_wrapper__8ANiX","shimmer":"CarBrend_shimmer__PhPr3"};